import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "reactstrap";
import { useFormik } from "formik";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../Components/Breadcrumb";
import Select from "react-select";
import { customStyles } from "../../utils/constant";
import PriceMatrixTable from "./components/PriceMatrixTable";
const BulkPriceList = () => {
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const [priceMatrix, setPriceMatrix] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [priceTypeData, setPriceTypeData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [qualityData, setQualityData] = useState([]);
  const [traceabilityData, setTraceabilityData] = useState([]);
  const [packSizeData, setPackSizeData] = useState([]);
  const [packBagData, setPackBagData] = useState([]);
  const [showMatrix, setShowMatrix] = useState(false);
  useEffect(() => {
    const apis = [
      { url: "category/getWithoutPaginationCategory", setter: setCategoryData },
      {
        url: "priceType/getWithoutPaginationPriceTypes",
        setter: setPriceTypeData,
      },
      { url: "packBag/getWithoutPaginationPackBags", setter: setPackBagData },
      { url: "country/getWithoutPaginationCountries", setter: setCountryData },
    ];
    apis.forEach(({ url, setter }) => {
      axiosInstance
        .get(url)
        .then((res) => setter(res.data?.data || []))
        .catch(() => setter([]));
    });
  }, []);

  const fetchByCategory = async (categoryId) => {
    if (!categoryId) {
      setQualityData([]);
      setTraceabilityData([]);
      setPackSizeData([]);
      return;
    }

    try {
      const response = await axiosInstance.get(
        `category/getCategoryWiseQualityTraceability/${categoryId}`,
      );
      const data = response.data.data;
      setTraceabilityData(data.traceabilityIds || []);
      setQualityData(data.qualityIds || []);
      setPackSizeData(data.packSizeIds || []);
    } catch (err) {
      setQualityData([]);
      setTraceabilityData([]);
    }
  };

  const initialValues = {
    country_id: editData?.country_id?._id || "",
    priceType_id: editData?.priceType_id?._id || "",
    category_id: editData?.category_id?._id || "",
    quality_id: editData?.quality_id?._id || "",
    traceability_id: editData?.traceability_id?._id || "",
    product_id: editData?.product_id?._id || "",
  };

  const { values, errors, handleSubmit, setFieldValue, touched } = useFormik({
    initialValues,
    enableReinitialize: false,
    onSubmit: async (values) => {
      setLoading(true);

      try {
        const payload = priceMatrix.map((item) => ({
          country_id: values.country_id,
          priceType_id: values.priceType_id,
          category_id: values.category_id,
          quality_id: values.quality_id || null,
          traceability_id: values.traceability_id || null,
          product_id: values.product_id || null,

          packBag_id: item.packBag_id,
          packSize_id: item.packSize_id,
          price: item.price,
          isActive: true,
        }));

        const response = await axiosInstance.post(
          "/priceList/createBulkPriceList",
          payload,
        );
        if (response.status === 200) {
          toast.success(response.data.message);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Something went wrong.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCategoryChange = async (selected) => {
    const catId = selected?.value || "";

    setFieldValue("category_id", catId);

    // Reset dependent fields
    setFieldValue("quality_id", "");
    setFieldValue("traceability_id", "");
    setFieldValue("product_id", "");
    setFieldValue("packSize_id", "");

    if (catId) {
      await fetchByCategory(catId);
    } else {
      setQualityData([]);
      setTraceabilityData([]);
      setPackSizeData([]);
    }
  };
  const getPriceMatrix = async () => {
    try {
      setLoading(true);

      const payload = {
        country_id: values.country_id,
        priceType_id: values.priceType_id,
        category_id: values.category_id,
        quality_id: values.quality_id,
        traceability_id: values.traceability_id,
      };

      const res = await axiosInstance.post(
        "/priceList/getPriceListFilter",
        payload,
      );

      setPriceMatrix(res.data.data || []);

      // Table show
      setShowMatrix(true);
    } catch (err) {
      toast.error(err.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (values.category_id) {
      fetchByCategory(values.category_id);
    } else {
      setQualityData([]);
      setTraceabilityData([]);
      setPackSizeData([]);
    }
  }, [values.category_id, categoryData]);

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Bulk Price List", path: "*" },
  ];

  const countryOptions = countryData.map((item) => ({
    label: item.countryName,
    value: item._id,
  }));
  const priceTypeOptions = priceTypeData.map((item) => ({
    label: item.priceTypeCode,
    value: item._id,
  }));
  const categoryOptions = categoryData.map((item) => ({
    label: item.categoryName,
    value: item._id,
  }));
  const qualityOptions = qualityData.map((item) => ({
    label: item.qualityName,
    value: item._id,
  }));
  const traceabilityOptions = traceabilityData.map((item) => ({
    label: item.traceabilityName,
    value: item._id,
  }));
  const packSizeOptions = packSizeData.map((item) => ({
    label: item.packSizeName,
    value: item._id,
  }));
  const packBagOptions = packBagData.map((item) => ({
    label: item.packBagName,
    value: item._id,
  }));

  const showButton =
  values.country_id &&
  values.priceType_id &&
  values.category_id &&
  (qualityOptions?.length === 0 || values.quality_id) &&
  (traceabilityOptions?.length === 0 || values.traceability_id);
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">Bulk Price List</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>

        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form>
                <div className="row">
                  <div className="col-sm-4 mt-2">
                    <label>Country</label>
                    <Select
                      options={countryOptions}
                      value={
                        countryOptions.find(
                          (opt) => opt.value === values.country_id,
                        ) || null
                      }
                      isClearable
                      styles={customStyles}
                      onChange={(selected) =>
                        setFieldValue("country_id", selected?.value || "")
                      }
                      placeholder="Select Country"
                    />
                    {touched.country_id && errors.country_id && (
                      <small className="text-danger">{errors.country_id}</small>
                    )}
                  </div>
                  <div className="col-sm-4 mt-2">
                    <label>Price Type</label>
                    <Select
                      options={priceTypeOptions}
                      value={
                        priceTypeOptions.find(
                          (opt) => opt.value === values.priceType_id,
                        ) || null
                      }
                      isClearable
                      styles={customStyles}
                      onChange={(selected) =>
                        setFieldValue("priceType_id", selected?.value || "")
                      }
                      placeholder="Select Price Type"
                    />
                    {touched.priceType_id && errors.priceType_id && (
                      <small className="text-danger">
                        {errors.priceType_id}
                      </small>
                    )}
                  </div>

                  <div className="col-sm-4 mt-2">
                    <label>Category</label>
                    <Select
                      options={categoryOptions}
                      value={
                        categoryOptions.find(
                          (opt) => opt.value === values.category_id,
                        ) || null
                      }
                      isClearable
                      styles={customStyles}
                      onChange={handleCategoryChange}
                      placeholder="Select Category"
                    />
                    {touched.category_id && errors.category_id && (
                      <small className="text-danger">
                        {errors.category_id}
                      </small>
                    )}
                  </div>

                  {qualityOptions && qualityOptions.length > 0 && (
                    <div className="col-sm-4 mt-4">
                      <label>Quality</label>
                      <Select
                        options={qualityOptions}
                        value={
                          qualityOptions.find(
                            (opt) => opt.value === values.quality_id,
                          ) || null
                        }
                        isClearable
                        styles={customStyles}
                        onChange={(selected) =>
                          setFieldValue("quality_id", selected?.value || "")
                        }
                        placeholder="Select Quality"
                      />
                      {touched.quality_id && errors.quality_id && (
                        <small className="text-danger">
                          {errors.quality_id}
                        </small>
                      )}
                    </div>
                  )}

                  {traceabilityOptions && traceabilityOptions.length > 0 && (
                    <div className="col-sm-4 mt-4">
                      <label>Source</label>
                      <Select
                        options={traceabilityOptions}
                        value={
                          traceabilityOptions.find(
                            (opt) => opt.value === values.traceability_id,
                          ) || null
                        }
                        isClearable
                        styles={customStyles}
                        onChange={(selected) =>
                          setFieldValue(
                            "traceability_id",
                            selected?.value || "",
                          )
                        }
                        placeholder="Select Source"
                      />
                      {touched.traceability_id && errors.traceability_id && (
                        <small className="text-danger">
                          {errors.traceability_id}
                        </small>
                      )}
                    </div>
                  )}
                {showButton && (
  <div className="text-center" style={{marginTop:"50px",marginLeft:"15px"}}>
    <Button
      color="primary"
      type="button"
      disabled={loading}
      onClick={getPriceMatrix}
    >
      {loading ? "Loading..." : "Get Price List"}
    </Button>
  </div>
)}
                </div>

                {showMatrix && (
                  <PriceMatrixTable
                    packSizeOptions={packSizeOptions}
                    packBagOptions={packBagOptions}
                    values={priceMatrix}
                    setValues={setPriceMatrix}
                    formValues={values}
                  />
                )}

                {showMatrix && (
                  <div className="text-center mt-4">
                    <Button
                      type="submit"
                      color="primary"
                      disabled={loading}
                      onClick={handleSubmit}
                    >
                      {loading ? (
                        <span className="d-inline-flex align-items-center gap-2">
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          />
                          Processing...
                        </span>
                      ) : (
                        "Save"
                      )}
                    </Button>
                    <Link to="/price-list">
                      <Button color="danger mx-2">Cancel</Button>
                    </Link>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BulkPriceList;
